import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { FamiliarSection } from '../components/FamiliarSection';
import { IdentificationSection } from '../components/IdentificationSection';
import { MechanismSection } from '../components/MechanismSection';
import { WhyNothingWorksSection } from '../components/WhyNothingWorksSection';
import { MethodSection } from '../components/MethodSection';
import { WhatChangesSection } from '../components/WhatChangesSection';
import { ObjectionsSection } from '../components/ObjectionsSection';
import { FinalOfferSection } from '../components/FinalOfferSection';
export function LandingPage() {
  return <main className="w-full" data-id="element-225">
      <HeroSection data-id="element-226" />
      <FamiliarSection data-id="element-227" />
      <IdentificationSection data-id="element-228" />
      <MechanismSection data-id="element-229" />
      <WhyNothingWorksSection data-id="element-230" />
      <MethodSection data-id="element-231" />
      <WhatChangesSection data-id="element-232" />
      <ObjectionsSection data-id="element-233" />
      <FinalOfferSection data-id="element-234" />
    </main>;
}